import { Component, OnInit } from '@angular/core';
import { GiftCardTypesModel, GiftCardModel } from 'src/app/models/gifcardVirtual.model';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { MessageService } from 'primeng/api';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ImageBarcode, ImageText } from 'src/app/models/image.model';
import { ImageService } from 'src/app/services/image.service';
import { AuthService } from 'src/app/services/auth.service';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'models-add-upd',
    templateUrl: 'models-add-upd.component.html'
})

export class ModelsComponent implements OnInit {

    id_modelo_gift_card: string;
    id_types_ncr: string;
    type_model: string;
    modelsFormGroup: FormGroup;    
    datasourceSelectModels: GiftCardModel[] = [];
    datasourceSelectTypes: GiftCardTypesModel[] = [];
    datasourceSelectTypesTemp: GiftCardTypesModel[] = [];    
    newModel: boolean = true;    
    colsTablaImageBarcode: any[];
    colsTablaImageText: any[];
    userCurrent: string;    
    model;
    loading: boolean = false;
    
    constructor(private giftCardService: GifcardVirtualService, 
        private messageService: MessageService,
        private formBuilder: FormBuilder,
        private imageService: ImageService,
        private authService: AuthService) { }

    ngOnInit() { 
        this.userCurrent = this.authService.getCurrentUser();
        this.model = JSON.parse(this.imageService.getModelEdit());        
        this.createModelsForm();

        if (this.model != null){
            this.populateSelectTypesAll();
            this.newModel = false;            
            this.id_modelo_gift_card = this.model.ID_TYPES;
            this.id_types_ncr = this.model.ID_TYPES_NCR;
            this.modelo_gif2.setValue(this.model.ID_TYPES_NCR, {onlySelf: true});
            this.modelo_gif2.disable();
            this.desc_modelo2.setValue(this.model.DESC_TYPES);
            this.type_model = this.model.TYPE_MODEL;
            this.desc_typemodel.setValue(this.model.TYPE_MODEL == 'G' ? 'VIRTUAL' : 'FÍSICO');
        }
        else{
            this.newModel = true;
            this.populateSelectTypes();
        }  
    }

    createModelsForm(){
        this.modelsFormGroup = this.formBuilder.group({
            selModeloGiftCard: ['', Validators.required],
            descModeloGiftCard: ['', [Validators.required, Validators.maxLength(100)]],
            descTypeGiftCard: new FormControl({ value: '', disabled: true }, Validators.required)
        });
    }

    populateSelectTypesAll(){
        this.loading = true; 
        this.giftCardService.GetGiftCardTypes().subscribe(
            (response: GiftCardTypesModel[]) => {            
                this.datasourceSelectTypes = response;  
                this.loading = false;         
            },
            (error) => {
                this.loading = false;
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar tipos de gift card.'});
            }
        )
    }

    populateSelectTypes(){
        this.loading = true; 
        this.giftCardService.GetGiftCardTypes().subscribe(
            (response: GiftCardTypesModel[]) => {            
                this.datasourceSelectTypes = response;  
                this.populateSelectModels();            
            },
            (error) => {
                this.loading = false;
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar tipos de gift card.'});
            }
        )
    }

    populateSelectModels(){
        this.giftCardService.GetGiftCardModels().subscribe(
            (response: GiftCardModel[]) => {            
                this.datasourceSelectModels = response; 
                this. matchModelsWithTypes();
                this.loading = false;   
            },
            (error) => {
                this.loading = false;
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar tipos locales de gift card.'});
            }
        )
    }
    
    matchModelsWithTypes(){ 
        this.datasourceSelectTypes = this.datasourceSelectTypes.filter((types) => {
             for (let index in this.datasourceSelectModels){
                if (types.id == this.datasourceSelectModels[index].ID_TYPES_NCR){
                    return false;
                }                    
             }
             return true;      
        });

        //console.log(this.datasourceSelectTypes);
    }

    saveModels(){
        if (this.newModel){
            if (this.modelsFormGroup.valid){     
                this.loading = true;                      
                let types = {
                    "p_types_ncr": this.id_types_ncr,
                    "p_desc_types" : this.desc_modelo2.value,
                    "p_type_model" : this.type_model,
                    "p_creationuser": this.userCurrent
                };
                console.log(types);
                this.imageService.CreateGiftCardModel(types).subscribe(
                    (response) => {                        
                        this.newModel = false;
                        this.loading = false;
                        this.messageService.add({severity:'success', summary: 'Éxito', detail:'El modelo se registro correctamente.'});
                    },
                    (error) => {
                        this.loading = false;
                        this.newModel = true;
                        this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al registrar el modelo.'});
                    }
                )
            }
            else{
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ingrese todos los campos obligatorios.'});
            }
        }
        else{            
            if (this.modelsFormGroup.valid){
                this.loading = true; 
                let types = {
                    "p_id_modelo_gift_card": this.id_modelo_gift_card,
                    "p_desc_types" : this.desc_modelo2.value,
                    "p_flag_activo": 1
                };
                this.imageService.UpdateGiftCardModel(types).subscribe(
                    (response) =>{
                        this.loading = false;
                        this.messageService.add({severity:'success', summary: 'Éxito', detail:'El modelo se actualizó correctamente.'});
                    },
                    (error) => {
                        this.loading = false;
                        this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al actualizar modelo.'});
                    }
                )
            }           
            
        }                
    }

    deleteModels(){
        this.loading = true;
        if (this.modelsFormGroup.valid){
            let types = {
                "p_id_modelo_gift_card": this.id_modelo_gift_card,
                "p_desc_types" : this.desc_modelo2.value,
                "p_flag_activo": 0
            };
            this.imageService.UpdateGiftCardModel(types).subscribe(
                (response) =>{
                    this.loading = false;
                    this.messageService.add({severity:'success', summary: 'Éxito', detail:'El modelo se dio baja correctamente.'});
                },
                (error) => {
                    this.loading = false;
                    this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al dar de baja al modelo.'});
                }
            )
        } 
    }

    onSelectTypes(){
        this.id_types_ncr = this.modelsFormGroup.get('selModeloGiftCard').value;
        for (let i=0; i < this.datasourceSelectTypes.length; i++){
            if (this.datasourceSelectTypes[i].id == Number(this.id_types_ncr)){
                this.desc_modelo2.setValue(this.datasourceSelectTypes[i].name);
                this.type_model = this.datasourceSelectTypes[i].useType;
                this.desc_typemodel.setValue(this.datasourceSelectTypes[i].useType == 'G' ? 'VIRTUAL' : 'FÍSICO');
                break;
            }
        }
    }

    onBack(){
        this.imageService.removeModelEdit();
    }

    get modelo_gif2(){
        return this.modelsFormGroup.get('selModeloGiftCard');
    }

    get desc_modelo2(){
        return this.modelsFormGroup.get('descModeloGiftCard');
    }

    get desc_typemodel(){
        return this.modelsFormGroup.get('descTypeGiftCard');
    }
}